import { useQuery } from '@tanstack/react-query';

import { FilterValues } from '@/hooks/use-filter-values';

import { getOverheadsSummary } from '../api';
import {
  OVERHEADS_STALE_TIME,
  OVERHEADS_SUMMARY_QUERY_KEY,
} from '../constants/overheads-query-keys';
import { mapOverheadsFilters } from './use-overheads';

/**
 * Summary totals for the current filter selection, converted to the
 * organization's default currency by the backend. Type/status filters are
 * excluded so the cards always show the full breakdown for the selected
 * period/projects/clients.
 */
export const useOverheadsSummary = ({ filters }: { filters: FilterValues['values'] }) => {
  return useQuery({
    queryKey: [OVERHEADS_SUMMARY_QUERY_KEY, filters],
    queryFn: () => {
      const apiFilters = mapOverheadsFilters(filters);
      return getOverheadsSummary({ ...apiFilters, types: undefined, statuses: undefined });
    },
    staleTime: OVERHEADS_STALE_TIME,
  });
};
